import {StudyContent} from './studyContentSchema';

function isLineTitle(line: string): string | undefined {
  if (line.startsWith('## ')) {
    const title = line.substring(3).trim();
    return title || undefined;
  }
  return undefined;
}

interface StudyContentSection {
  title: string;
  content: string[];
}

function mapStudyContentSectionToStudyContent(section: StudyContentSection): StudyContent {
  return {
    title: section.title,
    content: section.content.join('\n'),
  };
}

function createStudyContentSection(title: string, content: string[] = []): StudyContentSection {
  return {title, content};
}

/**
 * Split content by ## headers into StudyContent array.
 * The title is extracted from the text after ## (e.g. "## Title" -> "Title").
 * @throws if content is empty, no sections found, or any section has no content
 */
export function mapContentToStudyContent(content: string): StudyContent[] {
  if (!content || !content.trim()) {
    throw new Error('Content is required and cannot be empty');
  }

  const lines = content.split('\n');
  const sections: StudyContent[] = [];
  let currentSection: StudyContentSection | null = null;

  lines.forEach((lineRaw) => {
    const title = isLineTitle(lineRaw);

    if (title !== undefined) {
      if (currentSection !== null) {
        sections.push(mapStudyContentSectionToStudyContent(currentSection));
      }
      currentSection = createStudyContentSection(title);
    } else {
      // create no title section if started with regular line
      if (currentSection === null) {
        currentSection = createStudyContentSection('No Title');
      }
      currentSection.content.push(lineRaw);
    }
  });

  if (currentSection !== null) {
    sections.push(mapStudyContentSectionToStudyContent(currentSection));
  }

  if (sections.length === 0) {
    throw new Error('No sections found in content. Content must contain at least one ## header section.');
  }

  return sections;
}
